import { useState } from "react";
import { Smile } from "lucide-react";

import { EMOJI_CATEGORIES } from "../utils/constants";
import { ToolbarTriggerButton, DropdownPanel } from "./_shared";

const EmojiPicker = ({ isOpen, setIsOpen, onSelect, closeOthers }) => {
  const [activeCategory, setActiveCategory] = useState("Smileys");

  const handleToggleOpen = () => {
    closeOthers?.();
    setIsOpen(!isOpen);
  };

  return (
    <div className="relative">
      <ToolbarTriggerButton
        icon={Smile}
        label="Emoji"
        onClick={handleToggleOpen}
        active={isOpen}
      />

      <DropdownPanel isOpen={isOpen} width="w-80">
        <div className="p-2">
          <div className="flex gap-1 mb-2">
            {Object.keys(EMOJI_CATEGORIES).map((cat) => {
              const isActive = activeCategory === cat;
              return (
                <button
                  type="button"
                  key={cat}
                  onClick={() => setActiveCategory(cat)}
                  className={[
                    "px-2.5 py-1 text-[12px] font-normal tracking-wide rounded-md",
                    "transition-colors cursor-pointer",
                    "outline-none focus-visible:ring-2 focus-visible:ring-inputFocus/60",
                    isActive
                      ? "bg-btnHover text-mainText"
                      : "text-mutedText hover:text-mainText hover:bg-btnHover/50",
                  ].join(" ")}
                >
                  {cat}
                </button>
              );
            })}
          </div>

          <div className="grid grid-cols-9 gap-0.5 max-h-[200px] overflow-y-auto overscroll-contain">
            {EMOJI_CATEGORIES[activeCategory].map((emoji) => (
              <button
                type="button"
                key={emoji}
                onClick={() => {
                  onSelect(emoji);
                  setIsOpen(false);
                }}
                className="h-8 w-8 flex items-center justify-center text-[18px] rounded
                           hover:bg-btnHover transition-colors cursor-pointer
                           outline-none focus-visible:ring-2 focus-visible:ring-inputFocus/60"
              >
                {emoji}
              </button>
            ))}
          </div>
        </div>
      </DropdownPanel>
    </div>
  );
};

export default EmojiPicker;
